import { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  MotifFormField,
  MotifLabel,
  MotifSelect,
  MotifOption,
  MotifButton,
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
} from "@/libs/@ey-xd/motif-react";
import "./Attributes.css";
import { setAttribute, initialState } from "./AttributesSlice";
import {
  useListAttributesQuery,
  useDeleteAttributeMutation,
} from "@/services/customAtrributes/customAttributesReducer";
import { EntityType, AttributeType } from "./type";
import {
  customComparator,
  havingAddPermission,
  havingDeletePermission,
  havingEditPermission,
} from "@/utility/common";
import { useSelector } from "react-redux";
import {
  CREATE_BUTTON_VARIANT,
  DELETE_BUTTON_VARIANT,
  GetCommonDeleteImgButton,
  YES_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { CommonModalHeader } from "@/components/Modal/CommonModalHeader/CommonModalHeader";
import { useTrans } from "@/components/Functions/dateFunc";
import { customTableLoadingData } from "@/components/Table/CustomPaginationConstants";
import Table from "@/components/Table/table";
import CustomPagination from "@/components/Pagination/CustomPagination";
import { paginationPageSize, paginationPageSizeSelector } from "@/Constant";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
// import SearchInput from "@/components/SearchInput/SearchInput";
export default function AttributesManagement() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { caseId } = useParams();
  const dispatch = useDispatch();
  const retainState = useSelector(
    (e: any) => e.retainState.attributeListTabState
  );
  const [deleteAttribute] = useDeleteAttributeMutation();
  const [currentId, setCurrentId] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [deleteAttributeName, setDeleteAttributeName] = useState("");
  const permissions = useSelector((state: any) => state.permissions);
  const { AttributeDefinition } = permissions;
  const getPaginationObj: any = useMemo(() => {
    let value: any = {
      caseId: caseId,
      entityType: retainState?.entityType,
      PageNumber: retainState?.PageNumber || 1,
      PageSize: retainState?.PageSize || paginationPageSize,
      SearchText: retainState?.SearchText || "",
    };
    if (retainState?.SortOrder && retainState?.SortColumn) {
      value.SortOrder = retainState?.SortOrder;
      value.SortColumn = retainState?.SortColumn;
    }
    return value;
  }, [caseId, retainState]);
  const paginationObj = getPaginationObj;
  const {
    isFetching,
    isError,
    data: attributeListData,
    status: attributeApiStatus,
    refetch,
  } = useListAttributesQuery({ ...paginationObj });
  function handlePaginationData(data: any, columnTypesData: any) {
    dispatch(
      setComponentState1({
        entityName: "attributeListTabState",
        entityState: {
          SortOrder: data.SortOrder,
          SortColumn: data.SortColumn,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }
  useEffect(() => {
    dispatch(setAttribute({}));
  }, [dispatch]);
  const handleCreateNew = () => {
    dispatch(
      setAttribute({ ...initialState, entityType: retainState.entityType })
    );
    navigate(
      `/case/${caseId}/configuration/attributes?entityType=${retainState.entityType}`
    );
  };
  const handleDelete = async () => {
    setIsLoading(true);
    const requestBody = {
      id: currentId,
    };
    try {
      await deleteAttribute(requestBody).unwrap();
      refetch();
      setShowDelete(false);
    } catch (error) {
      setIsErrorVisible(true);
      const errorMessage =
        (error as { data?: { message?: string } }).data?.message ||
        "Attribute cannot be deleted";
      setErrorMessage(errorMessage);
      setShowDelete(false);
      if ((error as { status?: number })?.status === 400) {
        console.error("Error 400: Bad Request", errorMessage);
      } else {
        console.error("Failed to delete the attribute", errorMessage);
      }
    } finally {
      setIsLoading(false);
    }
  };
  function TitleComponent() {
    // const [quickSearch, setQuickSearch] = useState(retainState.SearchText || "");

    return (
      <>
        {havingAddPermission(AttributeDefinition) ? (
          <MotifButton
            size="small"
            variant={CREATE_BUTTON_VARIANT}
            onClick={handleCreateNew}
          >
            {t("pages.configuration.attributes.createAttributeButton")}
          </MotifButton>
        ) : (
          <></>
        )}
        {/* <MotifFormField>
          <SearchInput
            value={quickSearch}
            onChange={(e: any) => {
              setQuickSearch(e.target.value);
            }}
            onEnter={() => {
              dispatch(
                setComponentState1({
                  entityName: "attributeListTabState",
                  entityState: {
                    PageNumber: 1,
                    PageSize: paginationPageSize,
                    SearchText: quickSearch,
                    SortOrder: "",
                    SortColumn: "",
                    sortedColumnTypes: { ...resetSortStatus() },
                  },
                })
              );
            }}
            onClear={() => {
              dispatch(
                setComponentState1({
                  entityName: "attributeListTabState",
                  entityState: {
                    PageNumber: 1,
                    PageSize: paginationPageSize,
                    SearchText: "",
                    SortOrder: "",
                    SortColumn: "",
                    sortedColumnTypes: { ...resetSortStatus() },
                  },
                })
              );
              setQuickSearch("");
            }}
            placeholder={t("global.globalPlaceholder.quickSearchPlaceHolder")}
            withOutDebounce={true}
          />
        </MotifFormField> */}
      </>
    );
  }

  const handleEdit = (id: string) => {
    navigate(
      `/case/${caseId}/configuration/attributes/edit/${id}?entityType=${retainState.entityType}`
    );
  };

  // const ToggleCellRenderer = (_props: any) => {
  //   return <></>;
  // };

  const ActionsCellRenderer = (props: any) => {
    return (
      <>
        {havingDeletePermission(AttributeDefinition) && (
          <GetCommonDeleteImgButton
            onClick={() => {
              setShowDelete(true);
              setCurrentId(props.data.id);
              setDeleteAttributeName(props.data.name);
            }}
          ></GetCommonDeleteImgButton>
          // <CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
          //   <MotifButton
          //     className="action-delete-button"
          //     size="small"
          //     variant="secondary"
          //   >
          //     <MotifIcon
          //       fill="none"
          //       iconFunction={actionIcDelete24px}
          //       onClick={() => {
          //         setShowDelete(true);
          //         setCurrentId(props.data.id);
          //         setDeleteAttributeName(props.data.name);
          //       }}
          //     />
          //   </MotifButton>
          // </CommonTooltipWrapper>
        )}
        {/*
        <MotifButton
          size="small"
          variant="primary"
          onClick={() => handleEdit(props.data.id)}
        >
          <MotifIcon fill="none" iconFunction={contentIcCreate24px} />
        </MotifButton> */}
      </>
    );
  };

  const columnDefs = (handleEdit: (params: any) => void) => [
    {
      headerName: t("pages.configuration.attributes.attributeTableName"),
      field: "name",
      type: "nameType",
      sortable: true,
      unSortIcon: true,
      comparator: customComparator,
      flex: 1,
      onCellClicked: (params: any) => {
        if (havingEditPermission(AttributeDefinition)) {
          handleEdit(params?.data?.id);
        }
      },
      cellStyle: havingEditPermission(AttributeDefinition)
        ? { cursor: "pointer" }
        : { cursor: "default" },
      cellClass: "text-bold-underline",
      minWidth: 150,
    },
    {
      headerName: t("pages.configuration.attributes.attributeTableType"),
      field: "attributeType",
      cellRenderer: (params: any) => AttributeType[params.data.attributeType],
      type: "attributeType",
      unSortIcon: true,
      sortable: true,
      comparator: customComparator,
      flex: 1,
      minWidth: 150,
    },
    {
      cellRenderer: (params: any) => params?.data?.description || "",
      headerName: t("pages.configuration.attributes.attributeTableDescription"),
      field: "description",
      type: "descriptionType",
      sortable: true,
      unSortIcon: true,
      flex: 1,
      wrapText: true,
      autoHeight: true,
      cellClass: "overFlowWrapAnywhere",
      minWidth: 150,
    },
    // {
    //   headerName: "",
    //   field: "hide",
    //   sortable: false,
    //   cellRenderer: ToggleCellRenderer,
    //   maxWidth: 130,
    // },
    {
      headerName: "",
      field: "actions",
      sortable: false,
      cellRenderer: ActionsCellRenderer,
      maxWidth: 115,
      cellClass: "align-right",
      minWidth: 60,
    },
  ];
  let resetSortStatus = () => {
    let json: any = { ...retainState?.sortedColumnTypes };
    for (const key in json) {
      json[key] = { sort: null };
    }

    return json;
  };
  return (
    <div className="attributes-management-container">
      <div className="motif-body1-default-regular attribute-management-title">
        {t("pages.configuration.attributes.subtitle")}
      </div>
      <div>
        <MotifFormField className="attribute-type-select">
          <MotifLabel>
            {t("pages.configuration.attributes.attributeType")}
          </MotifLabel>
          <MotifSelect
            onChange={(value) =>
              dispatch(
                setComponentState1({
                  entityName: "attributeListTabState",
                  entityState: {
                    entityType: value,
                    PageNumber: 1,
                    PageSize: paginationPageSize,
                    SearchText: "",
                    SortOrder: "",
                    SortColumn: "",
                    sortedColumnTypes: { ...resetSortStatus() },
                  },
                })
              )
            }
            value={retainState.entityType || EntityType.Creditor}
            visibleOptions={3}
          >
            <MotifOption value={EntityType.Creditor}>
              {t("pages.configuration.attributes.attributeTypeCreditor")}
            </MotifOption>
            <MotifOption value={EntityType.Claim}>
              {t("pages.configuration.attributes.attributeTypeClaim")}
            </MotifOption>
            <MotifOption value={EntityType.ClaimItem}>
              {t("pages.configuration.attributes.attributeTypeClaimItem")}
            </MotifOption>
          </MotifSelect>
        </MotifFormField>
      </div>

      <>
        <div className="attribute-management-table">
          <Table
            columnDefs={columnDefs(handleEdit)}
            cellRenderers={isFetching ? [] : attributeListData?.results || []}
            title={
              EntityType[retainState.entityType] +
              " " +
              t("pages.configuration.attributes.title")
            }
            columnTypes={{ ...retainState.sortedColumnTypes }}
            handlePaginationData={handlePaginationData}
            paginationObj={paginationObj}
            defaultColDef={{
              cellStyle: {
                whiteSpace: "normal",
                lineHeight: "1.5",
              },
            }}
            description=""
            overlayNoRowsTemplate={
              isFetching
                ? t(customTableLoadingData)
                : isError
                ? t("global.globalNotifications.wentWrong")
                : t("global.globalNotifications.noRecords")
            }
            pagination={false}
            TitleComplement={() => <TitleComponent />}
          />
          <CustomPagination
            apiData={attributeListData}
            apiStatus={attributeApiStatus}
            currentpage={paginationObj.PageNumber}
            pageSize={paginationObj.PageSize}
            disableNext={!attributeListData?.hasMoreRecords}
            onChangePageSize={(page: number) => {
              dispatch(
                setComponentState1({
                  entityName: "attributeListTabState",
                  entityState: {
                    PageSize: page,
                    PageNumber: 1,
                  },
                })
              );
            }}
            onChangeNextPage={() => {
              dispatch(
                setComponentState1({
                  entityName: "attributeListTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber + 1,
                  },
                })
              );
            }}
            onChangePreviousPage={() => {
              dispatch(
                setComponentState1({
                  entityName: "attributeListTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber - 1,
                  },
                })
              );
            }}
            pageSizeSelector={paginationPageSizeSelector}
          />
        </div>
      </>

      <MotifModal
        onClose={() => setShowDelete(false)}
        show={showDelete}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="confirmationModalWrapper creditor_disabling_model">
          <MotifModalHeader headerIcon={CommonModalHeader()}></MotifModalHeader>

          <MotifModalBody style={{ paddingTop: "0px" }}>
            {useTrans(
              t,
              t("pages.configuration.attributes.deleteAttributeMessage", {
                attributeName: deleteAttributeName,
              }),
              "attributeName"
            )}
          </MotifModalBody>

          <MotifModalFooter>
            <MotifButton
              onClick={handleDelete}
              type={isLoading ? "loader" : "submit"}
              variant={DELETE_BUTTON_VARIANT}
            >
              {t("pages.configuration.attributes.deleteButton")}
            </MotifButton>
          </MotifModalFooter>
        </div>
      </MotifModal>

      <MotifModal
        onClose={() => setIsErrorVisible(false)}
        show={isErrorVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <MotifModalBody>{errorMessage}</MotifModalBody>

        <MotifModalFooter>
          <MotifButton
            onClick={() => {
              setIsErrorVisible(false);
              setShowDelete(false);
            }}
            variant={YES_BUTTON_VARIANT}
          >
            {t("global.globalActions.yes")}
          </MotifButton>
        </MotifModalFooter>
      </MotifModal>
    </div>
  );
}
